import { combineReducers } from 'redux';

import list from './list';
import selected from './selected';
import duplicate from './duplicate';
import changeStatus from './changeStatus';

export default combineReducers({
  list,
  selected,
  duplicate,
  changeStatus,
});
